import React, { useState } from "react";
import { MDBAnimation } from "mdbreact";
import { Member } from "./card";
export default function Work() {
  const [teamlist, setteamlist] = useState([
    {
      name: "Shaiharyaar Ahmad",
      p1: "Consectetur adipisicing elit. Possimus, praesentium?",
      p2:
        "Provident consectetur natus voluptatem quis tenetur sed beatae eius sint.",
      b1: "View Profile",
    },
    {
      name: "Zeeshan Yasin",
      p1: "Consectetur adipisicing elit. Possimus, praesentium?",
      p2:
        "Provident consectetur natus voluptatem quis tenetur sed beatae eius sint.",
      b1: "View Profile",
    },
    {
      name: "Usman Arshad",
      p1: "Consectetur adipisicing elit. Possimus, praesentium?",
      p2:
        "Provident consectetur natus voluptatem quis tenetur sed beatae eius sint.",
      b1: "View Profile",
    },
    {
      name: "Talha Fiaz",
      p1: "Consectetur adipisicing elit. Possimus, praesentium?",
      p2:
        "Provident consectetur natus voluptatem quis tenetur sed beatae eius sint.",
      b1: "View Profile",
    },
    {
      name: "Shahzaib Gakhar",
      p1: "Consectetur adipisicing elit. Possimus, praesentium?",
      p2:
        "Provident consectetur natus voluptatem quis tenetur sed beatae eius sint.",
      b1: "View Profile",
    },
  ]);
  const teamCards = teamlist.map((member) => {
    return (
      <Member
        name={member.name}
        para1={member.p1}
        para2={member.p2}
        btn={member.b1}
      />
    );
  });
  return (
    <div>
      <div className="content1">{teamCards}</div>
    </div>
  );
}
